<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" scrollable persistent>
      <v-card>
        <v-card-title>
          Ajouter un coli
          <v-spacer/>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>

        <v-card-text class="pa-8">

          <v-text-field disabled
                        outlined
                        label="Méthode"
                        dense
                        :error-messages="errors.delivery_method"
                        v-model="form.delivery_method"
          ></v-text-field>

          <v-text-field outlined
                        placeholder="Ex: 0555XXXXXX"
                        hint="Veuillez entrer le numéro de téléphone de l'utilisateur"
                        persistent-hint
                        single-line
                        :loading="isLoading"
                        dense
                        :error-messages="errors.phone"
                        v-model="form.phone"
          >
            <template v-slot:append>
              <v-btn color="gifty"
                     text
                     class="mb-2 v-btn--active"
                     :disabled="!form.phone || form.phone.length !== 10"
                     :loading="isLoading"
                     @click.stop="getUser">
                <v-icon left>mdi-magnify</v-icon>
                Recherche
              </v-btn>
            </template>
          </v-text-field>

          <v-alert v-if="notFound" type="error" dismissible>
            {{ notFound }}
          </v-alert>

          <div v-if="user && user.id" class="table-border rounded-lg mt-3 pa-4">
            <v-alert color="success" text>
              <v-icon color="success" left size="40">mdi-check-circle</v-icon>
              Utilisateur <strong>{{ form.request_data.customer_name }}</strong> trouvé avec succès !
            </v-alert>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                    label="Nom de l'utilisateur *"
                    v-model="form.request_data.customer_name"
                    outlined
                    dense
                    hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                    label="Téléphone de l'utilisateur *"
                    disabled
                    v-model="form.request_data.customer_phone"
                    outlined
                    dense
                    hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea rows="2"
                            hide-details="auto"
                            label="Note pour le livreur"
                            v-model="form.request_data.note_to_driver"
                            outlined
                            dense
                ></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-text-field hide-details="auto"
                              disabled
                              label="Wilaya *"
                              v-model="user.wilaya.name"
                              outlined
                              dense
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-autocomplete hide-details="auto"
                                label="Commune *"
                                v-model="form.request_data.commune"
                                :items="communes"
                                item-value="id"
                                item-text="name"
                                outlined
                                dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-text-field
                    label="Adresse de livraison *"
                    v-model="form.request_data.destination_text"
                    outlined
                    dense
                    hide-details="auto"
                ></v-text-field>
              </v-col>

            </v-row>
          </div>

        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="gifty"
                 class="white--text"
                 depressed
                 :disabled="!user || !user.id"
                 @click="saveData"
                 :loading="isLoading">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import axios from "axios";

export default {
  data() {
    return {
      dialog: false,
      isLoading: false,
      communeLoading: false,
      communes: [],
      notFound: null,
      form: {},
      errors: {},
      user: {},
      deliveryTypes: [
        {text: "Domicile", value: 1},
        {text: "Stop Desk", value: 2},
        {text: "Point de retrait", value: 3}
      ]
    };
  },
  methods: {
    open() {
      this.dialog = true
      this.user = {}
      this.form = {
        phone: "",
        delivery_method: "maystro",
        request_data: {},
      }
    },
    saveData() {
      this.errors = {}
      this.isLoading = true;
      HTTP.post("/v1/refill-card-delivery/parcels/store", this.form).then(() => {
        this.isLoading = false;
        this.dialog = false;
        this.$emit('refresh')
        this.$successMessage = "Cet élément a été ajouté avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        this.errors = err.response?.data?.errors || {};
        console.log(err);
      });
    },
    getCommunes(wilayaId) {
      this.communeLoading = true;
      HTTP.get("/v1/refill-card-delivery/parcels/" + wilayaId + "/communes")
          .then((res) => {
            this.communes = res.data.data;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.communeLoading = false;
          });
    },
    getUser() {
      this.isLoading = true;
      this.notFound = null;
      this.user = {};

      let phone = this.form.phone.trim();
      if (phone.startsWith('0')) {
        phone = '+213' + phone.substring(1);
      }

      HTTP.post("/v1/refill-card-delivery/parcels/check-user", {
        phone
      }).then((res) => {
        this.isLoading = false;
        this.user = res.data.data ?? {};

        if (!res.data.data) {
          this.notFound = "Cet utilisateur n’existe pas dans notre base de données.";
        } else {
          this.getCommunes(this.user.wilaya_id)
          this.form.user_id = this.user.id
          this.form.request_data = {
            customer_name: this.user.name || '',
            customer_phone: this.user.phone || '',
            destination_text: this.user.wilaya?.name || '',
            note_to_driver: '',
            express: false,
            external_id: '',
            product_price: 0,
            delivery_type: 1,
            commune: this.user.commune_id || '',
            details: [],
          }
        }
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>

</style>